<template>
   <div class="solutions" id="solutions" v-if="solutionsData.length > 0">
      <p class="solutionTitle">解决方案</p>
      <div class="swiper-container">
        <i class="fa fa-angle-left btn-prev" @click="solutionSlide(0)"></i>
        <swiper :options="swiperOption" ref="solutionSwiper" class="solutionSwiper">
          <swiper-slide v-for="(slide, index) in solutionsData" :key="index">
            <div class="solutionTag-container">
              <div class="solutionTag" @click="locationToS(slide.url)">
                <div class="subImage" :style="{backgroundImage: 'url(' + getImgUrl(slide.imgURL) + ')' }" />
                <div class="subCtx">
                  <p class="subTile">
                    <span class="titleDot"></span>
                    {{slide.title}}
                    <span class="titleDot"></span>
                  </p>
                  <p class="subDetail">{{slide.detail}}</p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <i class="fa fa-angle-right btn-next" @click="solutionSlide(1)"></i>
      </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
    name: 'homeSolutions',
    components: {
        swiper,
        swiperSlide,
    },
    props: {
        solutionsData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            swiperOption: {
                freeMode: false,
                slidesPerView: 5,
                spaceBetween: 5,
                breakpoints: {
                    1840: {
                        slidesPerView: 4,
                    },
                    1520: {
                        slidesPerView: 3,
                    },
                    1120: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 1,
                    },
                },
            },
        };
    },
    computed: {
        solutionSwiper() {
            return this.$refs.solutionSwiper.swiper;
        },
    },
    methods: {
        getImgUrl(url) {
            return `${process.env.STATIC}${url}`;
        },
        solutionSlide(status) {
            if (status) {
                this.solutionSwiper.slideNext();
            } else {
                this.solutionSwiper.slidePrev();
            }
        },
        locationToS(url) {
            if (url && url !== '') {
                window.open(`${window.location.origin}${url}`, '_blank');
            }
        },
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
.solutions
    width 100%
    height 750px
    margin-top 142px
    display flex
    align-items center
    justify-content flex-start
    flex-direction column
    bg_imgNone('../../../static/dataMock/homePage/HPbanner2.png')
    @media (max-width: 1980px)
      .solutionTitle
        font-size $font-size-title
    @media (max-width: 768px)
      margin-top 55px
      .solutionTitle
        font-size 1.44rem
    .solutionTitle
      margin-top 3%
      margin-bottom 6%
    .swiper-container
      width 100%
      height 56%
      display flex
      justify-content space-around
      .btn-prev
        dom_center()
        font-size 80px
        margin-left 10%
      .btn-next
        dom_center()
        font-size 80px
        margin-right 10%
      .solutionSwiper
        width 60%
        overflow hidden
        height 100%
        .solutionTag-container
          position: relative;
          //left: calc(50% - 67px);
          width 100%
          height 100%
          .solutionTag
            dom_center()
            max-width 210px
            height 100%
            position relative
            cursor pointer
            .subImage
              width 100%
              height 100%
              background-size: 100% 100%
              border-radius:8px
              background-repeat: no-repeat
            @media (max-width: 1980px)
              .subCtx
                height 0
                visibility hidden
                .subTile
                  font-size 16px
                .subDetail
                  line-height 21px
            @media (max-width: 768px)
              .subCtx
                height 55%
                visibility visible
                .subDetail
                  line-height: 16px;
                  font-size: 10px;
            .subCtx
              position absolute
              bottom 0
              display flex
              align-items center
              justify-content flex-start
              flex-direction column
              width 100%
              padding 14px
              background-image: linear-gradient(180deg, rgba(47,172,240,0.92) 0%, #0060CB 100%)
              border-radius:0px 0px 8px 8px
              font-size $font-size-text
              .subTile
                width: 100%
                display: flex
                align-items: center
                line-height: 15px
                justify-content: space-around

                font-weight bold
                margin-top 5%
                .titleDot
                  display block
                  width 7px
                  height 7px
                  border-radius 50% 50%
                  background-color rgba(7, 243, 255, 1)
              .subDetail
                margin-top 5%
                text-align justify
            &:hover
              .subCtx
                height 55%
                visibility visible
                transition height 0.5s ease
</style>



// WEBPACK FOOTER //
// src/pages/index/home-solutions.vue